/** 简体中文。缺失的键回退到英文，不会显示成键名本身。 */
const zh = {
  Nav: {
    Home: '首页',
    Dashboard: '总览',
    Account: '账号',
    Cards: '卡片',
    Keychip: 'Keychip',
    Import: '导入',
    Announcements: '公告',
    Contributors: '致谢',
    SignIn: '登录',
    SignUp: '注册',
    SignOut: '退出登录',
    Games: '游戏',
    Theme: '主题',
    Language: '语言',
  },
  Common: {
    Profile: '个人资料',
    Rating: 'Rating',
    PlayRecord: '游玩记录',
    MusicList: '乐曲列表',
    Rival: '对手',
    UserRanking: '玩家排行',
    Setting: '设置',
    Loading: '加载中…',
    Empty: '暂无内容。',
    Error: '出错了。',
    Retry: '重试',
    Save: '保存',
    Cancel: '取消',
    Remove: '移除',
    Add: '添加',
    Close: '关闭',
    Colon: '：',
    Level: '等级',
    Score: '分数',
    PlayCount: '游玩次数',
    LastPlay: '最后游玩',
    Page: '第 {{page}} / {{total}} 页',
    Previous: '上一页',
    Next: '下一页',
    NoGameData: '还没有这个游戏的存档。打一个币之后就会出现在这里。',
    NoCard: '请先绑定卡片——卡片由机台创建，门户不能凭空生成。',
    Export: '导出',
    Name: '名称',
    Rank: '名次',
    Player: '玩家',
    Id: 'ID',
    Total: '合计',
    Never: '从未',
  },
  Auth: {
    Username: '用户名',
    Password: '密码',
    Email: '邮箱',
    DisplayName: '显示名称',
    UsernameOrEmail: '用户名或邮箱',
    SignInTitle: '登录',
    SignUpTitle: '创建账号',
    SignInAction: '登录',
    SignUpAction: '创建账号',
    NoAccount: '还没有账号？',
    HaveAccount: '已经有账号了？',
    ForgotPassword: '忘记密码？',
    ResetTitle: '重置密码',
    ResetAction: '重置密码',
    SendCode: '发送验证码',
    Code: '验证码',
    NewPassword: '新密码',
    TotpTitle: '两步验证',
    TotpPrompt: '请输入验证器应用中的六位数字。',
    TotpAction: '验证',
    SignedOut: '你已退出登录。',
  },
  Home: {
    Tagline: '为 CHUNITHM、maimai DX 与 O.N.G.E.K.I. 提供的网络服务。',
    GetStarted: '开始使用',
    OpenDashboard: '打开总览',
  },
  Dashboard: {
    Title: '总览',
    Games: '你的游戏',
    NoGames: '还没有任何存档。',
    ServerRank: '服务器排名',
    TotalPlayers: '共 {{total}} 名玩家',
    Unranked: '未上榜',
  },
  Account: {
    Title: '账号',
    Roles: '角色',
    Joined: '注册时间',
    ChangePassword: '修改密码',
    CurrentPassword: '当前密码',
    Updated: '已保存。',
    MustChange: '请先设置新密码，之后才能使用站点的其余功能。',
    ConfirmPassword: '确认新密码',
    PasswordMismatch: '两次输入的密码不一致。',
    PasswordRule: '至少 8 个字符。',
  },
  Admin: {
    Title: '管理',
    Forbidden: '你没有权限查看此页面。',
    Players: '玩家',
    Search: '搜索',
    Status: '状态',
    Active: '正常',
    Banned: '已封禁',
    Ban: '封禁',
    Unban: '解封',
    BanReasonPrompt: '封禁理由（玩家可见）：',
    Mail: '邮件',
    MailHint: '用于发送验证码和密码重置码。未配置时验证码会写进服务器日志。',
    MailEnabled: '启用发信',
    MailHost: 'SMTP 主机',
    MailPort: '端口',
    MailSecure: '隐式 TLS（465 端口）',
    MailUser: '用户名',
    MailPassword: '密码',
    MailPasswordKept: '留空则不修改',
    MailFrom: '发件人',
    MailTestTo: '测试发送至',
    MailTest: '发送测试',
    MailTestSent: '测试邮件已发送。',
  },
  Cards: {
    Title: '卡片',
    AccessCode: '门禁码',
    Registered: '注册时间',
    LastUsed: '最后使用',
    Default: '默认',
    MakeDefault: '设为默认',
    Bind: '绑定卡片',
    BindHint: '输入机台读卡时显示的 20 位门禁码。',
    Unbind: '解绑',
    UnbindConfirm: '解绑这张卡？存档仍然保留在服务器上。',
    Empty: '还没有绑定任何卡片。',
  },
  Keychip: {
    Title: 'Keychip',
    Serial: '序列号',
    Memo: '备注',
    Allowed: '已放行',
    Empty: '没有已注册的 keychip。',
    Generate: '生成 keychip',
    Trusted: '受信任的 keychip',
  },
  Import: {
    Title: '导入',
    Intro: '从其他服务器迁入存档。',
    Unavailable: '本服务器尚未开放导入功能。',
  },
  Announcements: { Title: '公告', Empty: '暂无公告。', Posted: '发布于' },
  Contributors: { Title: '致谢', Intro: 'QuiltNET 建立在以下项目公开的工作之上。' },
  Eula: { Title: '使用条款', Accept: '我接受', Required: '请先接受使用条款。' },
  Banned: {
    Title: '账号已被停用',
    Intro: '该账号无法使用本服务。',
    Appeal: '如果你认为这是误判，请联系运营者。',
  },
  Error: {
    PageTitle: '这个页面出错了',
    PageHint: '站点其余部分仍可使用。可以重试，或换一个页面。',
    Retry: '重试',
  },
  NotFound: { Title: '页面不存在', Intro: '找不到这个页面。', Home: '回到首页' },
  Chuni: {
    Title: 'CHUNITHM',
    Character: '角色',
    UserBox: '个性化',
    Nameplate: '名牌',
    Trophy: '称号',
    MapIcon: '地图图标',
    SystemVoice: '系统语音',
    Stage: '舞台',
    Avatar: '形象',
    OverPower: 'Over Power',
    Friend: '对手',
  },
  Mai2: {
    Title: 'maimai DX',
    Photos: '照片',
    DxPass: 'DX Pass',
    Circle: 'CiRCLE',
    Festa: 'Festa',
    ServerMissions: '服务器任务',
    PointExchanges: '积分兑换',
    Deluxe: 'DX',
    Standard: 'STD',
  },
  Ongeki: {
    Title: 'O.N.G.E.K.I.',
    Battle: '战斗',
    Card: '卡片',
    CardGallery: '卡片图鉴',
    MusicRanking: '乐曲排行',
    BattlePoint: 'Battle Point',
    TechScore: 'Technical',
    BattleScore: 'Battle',
  },
} as const;

export default zh;
